import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconWorkflowShapes20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconWorkflowShapes20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m14.807 7.622 1.768-1.768a.5.5 0 0 0 0-.707l-1.768-1.768a.5.5 0 0 0-.707 0l-1.767 1.768a.5.5 0 0 0 0 .707L14.1 7.622a.5.5 0 0 0 .707 0m2.829-.708a2 2 0 0 0 0-2.828l-1.768-1.768a2 2 0 0 0-2.828 0l-1.768 1.768a2 2 0 0 0-.44.664H8.918A3.501 3.501 0 1 0 4.75 8.92V11H4a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2h-.75V8.92a3.5 3.5 0 0 0 2.67-2.67h1.911c.098.242.245.468.44.664l1.769 1.768c.197.198.425.345.67.443v1.965A3.501 3.501 0 0 0 14.5 18a3.5 3.5 0 0 0 .71-6.928V9.12c.239-.097.463-.243.658-.438zM7.5 13a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm0-7.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m7 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconWorkflowShapes20);
